import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {FormattedDate} from 'react-intl';

import {parseDate} from '../../util';

import ParticipantLink from '../Participant/ParticipantLink';
import ThreadFile from '../../../public/js/components/Util/ThreadFile';
import ThreadWorkflowStatusEdit from './ThreadWorkflowStatusEdit';
import {WhenGranted} from '../util/Permissions';
import {getCurrentThread} from '../../redux/selectors';
import ThreadOwnerEdit from './ThreadOwnerEdit';
import ThreadNoteEdit from './ThreadNoteEdit';
import ParticipantAttributes from '../Participant/ParticipantAttributes';

import styles from './ThreadInfo.module.css';

const ThreadInfo = ({open, thread, threadFiles}) => (
    <aside className={open ? styles.open : styles.closed}>
        <div className={styles.content}>
            <table className={styles.infoTable}>
                <tbody>
                <tr>
                    <th><FormattedMessage id="thread.createdAt"/>:</th>
                    <td><FormattedDate value={parseDate(thread.createdAt)}/></td>
                </tr>
                {thread.updatedAt
                    ? <tr>
                        <th><FormattedMessage id="thread.updatedAt"/>:</th>
                        <td><FormattedDate value={parseDate(thread.updatedAt)}/></td>
                    </tr>
                    : null
                }
                <tr>
                    <th className={styles.withSpace}><FormattedMessage id="thread.author"/>:</th>
                    <td className={styles.withSpace}><ParticipantLink participant={thread.author}/></td>
                </tr>
                <WhenGranted permission="thread.show.owner">
                    <tr>
                        <th><FormattedMessage id="thread.owner"/>:</th>
                        <td>{thread.owner ? <ParticipantLink participant={thread.owner}/> : null}</td>
                    </tr>
                </WhenGranted>
                <WhenGranted permission="thread.show.note">
                    <tr>
                        <th className={styles.withSpace} colSpan={2}>
                            <FormattedMessage id="thread.note"/>:
                        </th>
                    </tr>
                </WhenGranted>
                <WhenGranted permission="thread.show.note">
                    <tr>
                        <td colSpan={2}>
                            <ThreadNoteEdit/>
                        </td>
                    </tr>
                </WhenGranted>
                <tr>
                    <th className={styles.withSpace} colSpan={2}>
                        <FormattedMessage id="thread.files"/>:
                    </th>
                </tr>
                {threadFiles.length > 0
                    ? <tr>
                        <td colSpan={2}>
                            <ul className={styles.fileList}>
                                {threadFiles.map((threadFile) => (
                                    <li key={threadFile}>
                                        <ThreadFile threadFile={threadFile}/>
                                    </li>
                                ))}
                            </ul>
                        </td>
                    </tr>
                    : <tr>
                        <td colSpan={2}><FormattedMessage id="thread.no_files"/></td>
                    </tr>
                }
                <WhenGranted permission="thread.edit.owner">
                    <tr>
                        <th colSpan={2}>
                            <FormattedMessage id="thread.owner"/>
                        </th>
                    </tr>
                </WhenGranted>
                <WhenGranted permission="thread.edit.owner">
                    <tr>
                        <td colSpan={2}>
                            <ThreadOwnerEdit/>
                        </td>
                    </tr>
                </WhenGranted>
                <WhenGranted permission="thread.edit.workflow">
                    <tr>
                        <th colSpan={2}>
                            <FormattedMessage id="thread.workflowStatus"/>
                        </th>
                    </tr>
                </WhenGranted>
                <WhenGranted permission="thread.edit.workflow">
                    <tr>
                        <td colSpan={2}>
                            <ThreadWorkflowStatusEdit thread={thread}/>
                        </td>
                    </tr>
                </WhenGranted>
                <tr>
                    <td colSpan={2}>
                        <ParticipantAttributes/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </aside>
);

export default connect((state) => {
    const thread = getCurrentThread(state);

    return {
        thread,
        threadFiles: thread.files,
        open: state.get('threadSidebar'),
    };
})(ThreadInfo);
